import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import DemoForm from './DemoForm';
import PartnersSection from '../Home/PartnersSection';
import BenefitsSection from './BenefitsSection';
import SEO from '../../components/common/SEO';

const DemoRequestPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Contact"
        description="Get in touch with Elixir for wholesale inquiries, product questions, or to share your experience. We'd love to hear from you about our premium Mediterranean honey varieties."
        keywords="
          Elixir contact,
          honey wholesale inquiry,
          Mediterranean honey contact,
          honey product questions,
          Elixir customer service,
          honey business inquiry,
          premium honey contact
        "
      />
      <Header />

      <main className="flex-grow">
        {/* Hero Section with Form */}
        <section className="bg-white mb-24">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row lg:min-h-[600px]">
              {/* Right side - Form */}
              <div className="flex w-full lg:w-1/2 p-6 lg:p-12 items-center">
                <div>
                  <h1 className="text-5xl font-semibold text-[#D4AF37] mb-6">Request a demo</h1>

                  <p className="text-xl text-[#202a44] mb-10">
                    We'd love to hear from you! Whether you have a question about our honey, a
                    wholesale inquiry, or just want to share your Elixir experience, please don't
                    hesitate to reach out.
                  </p>

                  <DemoForm />
                </div>
              </div>
              {/* Left side - Image */}
              <div className="hidden lg:flex w-full lg:w-1/2">
                <img
                  src="/images/contact-us.webp"
                  alt="Modern architecture"
                  className="w-full object-cover rounded-2xl"
                />
              </div>
            </div>
          </div>
        </section>
        {/* FAQ and Internal Links Section */}
        <section className="max-w-3xl mx-auto px-4 py-8 mt-8 mb-12 bg-[#f7fbff] rounded-xl shadow">
          <h2 className="text-xl font-semibold text-[#d4af37] mb-2">Frequently Asked Questions</h2>
          <ul className="text-[#475467] text-base space-y-2 mb-4">
            <li><b>How soon will I get a reply?</b> – We respond to all inquiries within 24 hours on business days.</li>
            <li><b>Do you ship internationally?</b> – Yes, we ship our honey worldwide. Shipping fees and times vary by destination.</li>
            <li><b>Can I request a custom order or bulk purchase?</b> – Absolutely! Please mention your needs in the form and our team will assist you.</li>
          </ul>
          <div className="mb-4 text-[#475467] text-base">Our customer service team is dedicated to providing you with a prompt, friendly, and helpful experience. We value every question and look forward to helping you discover the world of Elixir honey.</div>
          <div className="flex flex-wrap justify-center gap-4 mt-4">
            <a href="/shop" className="text-[#d4af37] underline hover:text-yellow-600">Shop Honey</a>
            <a href="/about" className="text-[#d4af37] underline hover:text-yellow-600">About Elixir</a>
            <a href="/blog" className="text-[#d4af37] underline hover:text-yellow-600">Honey Blog</a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DemoRequestPage;
